import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import NavBar from '../components/Menu/NavBar'
import { pageStyle } from '../components/UIComponent/CommonStyle'
import MyLeave from '../components/MyLeave';
import { setLocalStorageSettings } from '../components/Function/globalFunction';

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function MyLeavePage({ routing, routingId, source }) {
    const classes = useStyles();
    setLocalStorageSettings({
        'selectedIndex': 3,
        'isMyRequestOpen': 'true',
        'isApplicationOpen': 'false',
        'isLeaveApprovalOpen': 'false',
        'isHRAdminOpen': 'false'
    });

    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar />
            <MyLeave routing={routing} routingId={routingId} source={source} />
        </div>
    )
}